import { Component } from "react";

interface ErrorBoundaryProps {
	readonly children: React.ReactNode;
	readonly fallback: React.ReactNode;
}

interface ErrorBoundaryState {
	hasError: boolean;
}
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	public static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	public constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	public override shouldComponentUpdate(): boolean {
		return true;
	}

	public override componentDidCatch(error: Error, info: React.ErrorInfo) {
		console.error("ErrorBoundary caught an error", error, info);
	}

	public override render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return this.props.fallback;
		}

		return this.props.children;
	}
}